import { startWhenDomReady } from "./map-app-live.js";

startWhenDomReady();
